/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterCSmall = createReactComponent("letter-c-small", "IconLetterCSmall", [
  ["path", { d: "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", key: "svg-0" }]
]);

export { IconLetterCSmall as default };
//# sourceMappingURL=IconLetterCSmall.js.map
